import { render, staticRenderFns } from "./message-form-row.vue?vue&type=template&id=03d03714&scoped=true&"
import script from "./message-form-row.vue?vue&type=script&lang=js&"
export * from "./message-form-row.vue?vue&type=script&lang=js&"
import style0 from "./message-form-row.vue?vue&type=style&index=0&id=03d03714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d03714",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCombobox,VForm,VIcon})
